export default function ProfileImageUpload({
  userImage,
  loading,
  onSelectFile,
  fileInputRef,
}) {
  return (
    <div className="profile-upload-wrapper">
      <div
        className={`profile-upload ${
          loading ? "profile-upload--loading" : ""
        }`}
        onClick={() => !loading && fileInputRef.current?.click()}
      >
        <input
          type="file"
          accept="image/jpeg, image/png, .jpg, .jpeg, .png"
          ref={fileInputRef}
          hidden
          
          onChange={onSelectFile}
        />

        {loading ? (
          <div className="profile-upload__loading">
            <img
              src="/loader.gif"
              alt="Uploading"
              className="profile-upload__loader"
            />
            <p className="profile-upload__loading-text">
              Uploading image...
            </p>
          </div>
        ) : (
          <div className="profile-upload__content">
            <div className="profile-upload__avatar">
              {userImage ? (
                <img
                  src={userImage}
                  alt="Profile"
                  className="profile-upload__preview"
                />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 16.2A4.5 4.5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.3" />
                  <polyline points="16 16 12 12 8 16" />
                  <line x1="12" y1="12" x2="12" y2="21" />
                </svg>
              )}
            </div>

            <p className="profile-upload__title">
              {userImage ? "Change Profile Photo" : "Upload Profile Photo"}
            </p>

          </div>
        )}
      </div>
    </div>
  );
}
